module.exports = __webpack_public_path__ + "static/media/WEB20.0b38a6e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB20.jpg
// module id = 90
// module chunks = 0